import {SET_ACTIVE_CONTAINER} from "./consants";

export function setActiveContainer(path) {
  return (dispatch) => {
    dispatch({type: SET_ACTIVE_CONTAINER, payload: path});
  }
}